import { HTTP } from './http';

export const requestRegisterUser = (model) => new Promise((resolve, reject) => HTTP.post('/auth/register', model)
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestLogin = (model) => new Promise((resolve, reject) => HTTP.post('/auth/login', model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));


export const requestResetPassword = (model) => new Promise((resolve, reject) => HTTP.post('/auth/password-reset', model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestChangePassword = (model) => new Promise((resolve, reject) => HTTP.post('/auth/password-change', model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));


export const requestUpdateState = state =>
  new Promise((resolve, reject) =>
    HTTP.post('/me/update-appointment-state', { appointment_state: state })
      .then(response => ((response.status === 200) ? resolve : reject)(response))
      .catch(err => reject(err.response))
  );

export const requestConfirmPassword = (model) => new Promise((resolve, reject) => HTTP.post('/auth/password-reset-confirm', model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestCurrentUser = () => new Promise((resolve, reject) => HTTP.get('/me')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestUpdateResponses = id => new Promise((resolve, reject) => HTTP.patch('/me/update-responses',
  {
    id,
  })
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

// WHY: Fake API calls to test things on
// export const requestRegisterUser = () => new Promise((resolve, reject) => setTimeout(() => resolve({}), 1000));
// export const requestLogin = () => new Promise((resolve, reject) => setTimeout(() => resolve({}), 1000));
// export const requestResetPassword = () => new Promise((resolve, reject) => setTimeout(() => resolve({}), 1000));
// export const requestConfirmPassword = () => new Promise((resolve, reject) => setTimeout(() => resolve({}), 1000));

export const requestFakeUserToken = (model) => new Promise((resolve, reject) => HTTP.get(
  '/mdlive/fake-user-token',
  model.header,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));


export const requestUserToken = () => new Promise((resolve, reject) => HTTP.get('/mdlive/user-token')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));


export const requestAccountVerification = (model) => new Promise((resolve, reject) => HTTP.post(
  '/auth/confirm-sign-up',
  model,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

// export const requestAccountVerification = () => new Promise((resolve, reject) => {
//   resolve({ status: 200 });
//   reject({});
// });

export const requestResendVerification = (model) => new Promise((resolve, reject) => HTTP.post(
  '/auth/resend-verification-email',
  model,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestExtendToken = () => new Promise((resolve, reject) => HTTP.post(
  '/auth/extend-token',
  null,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestExtendMdLivetoken = (token) => new Promise((resolve, reject) => HTTP.post(
  '/mdlive/extend-token',
  {
    jwt_token: token,
  },
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestExtendAnswerToken = () => new Promise((resolve, reject) => HTTP.post(
  '/answers/extend-token',
  null,
)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/auth.js